export const loadState = () => {
    try {
        // console.log('load state function');
        const serializedState = localStorage.getItem('SevanestAdmin');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (error) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('SevanestAdmin', serializedState);
    } catch (error) {

    }
}
